import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly, secure, samesite=lax cookie set by the backend.
// The JWT is never persisted in localStorage (XSS-safe). An in-memory copy is kept
// only for the current session so non-XHR flows (file/PDF links) can authorize too.
let accessToken = null;
export const setAuthToken = (t) => { accessToken = t || null; };
export const getAuthToken = () => accessToken;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
